export default {
  SCAN_DOCUMENTS: 'ScanDocuments',
  DOCUMENTS_SCANNER: 'documentsScanner',
};
